// removed by extract-text-webpack-plugin
module.exports = {"LoadingContainer":"_1zmJFAE-LsobJkpQXimVNV","SpinnerSvg":"_1GH6bClIVk4kotrg77USA5","spin":"RVKxHWNhxwJ4dxNj26Ji9","LoadingBox":"_1xYNy-m9nHeJSa53GneCLW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner/index.css
// module id = 493
// module chunks = 0